import { render } from "./Pay.vue?vue&type=template&id=256606d4&scoped=true"
import script from "./Pay.vue?vue&type=script&lang=js"
export * from "./Pay.vue?vue&type=script&lang=js"

import "./Pay.vue?vue&type=style&index=0&id=256606d4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-256606d4"

export default script